import { ELIGIBILITY_CHECK_FIELDS } from '../constants/eligibilityCheckFields';
import { ELIGIBILITY_ERROR_CODES as CODES } from '../constants/eligibilityErrorCodes';

// CVS Caremark's field-set (ZIP / real-time check) — the only paying org on
// this field-set. Failures divert to NotEligible only for it; orgs on other
// field-sets fall through to the employee-search retry.
const NOT_ELIGIBLE_FIELD_SET = ELIGIBILITY_CHECK_FIELDS.FN_LN_DOB_AND_EMPID_OR_ZC;

// Soft-failure codes that land the user on /step/not-eligible. Every recognized
// failure code routes here for the field-set above.
const NOT_ELIGIBLE_CODES = new Set<string>([
  CODES.ELIGIBLE_USER_NOT_QUALIFIED,
  CODES.ELIGIBILITY_TERMINATED,
  CODES.ELIGIBILITY_UNDETERMINED,
  CODES.NOT_FOUND_PAYING_ORG,
  CODES.NOT_FOUND_FN_LN_DOB_EID,
  CODES.NOT_FOUND_FN_LN_DOB,
  CODES.NOT_FOUND_EID_DOB,
]);

/**
 * Whether a failed eligibility check should land on /step/not-eligible rather
 * than the employee-search retry: true for a recognized failure code on CVS
 * Caremark's ZIP field-set.
 */
export function shouldRouteToNotEligible(
  code: string | undefined,
  eligibilityCheckFields: string | undefined
): boolean {
  const isCvsFieldSet = eligibilityCheckFields === NOT_ELIGIBLE_FIELD_SET;
  const isNotEligibleCode = code != null && NOT_ELIGIBLE_CODES.has(code);
  return isCvsFieldSet && isNotEligibleCode;
}
